
















































import Vue from "vue";
import { SKILL_PRACTICE_TYPES } from "@tt-app/constants";

import iconClose from "@joyz/app-core/assets/icons/black/Close.svg";
import iconListeningDrill from "@joyz/app-core/assets/icons/default/DrillListening.svg";
import iconPronunciationDrill from "@joyz/app-core/assets/icons/default/DrillPronunciation.svg";
import iconRadio from "@joyz/app-core/assets/icons/misc/TT4WRadio.svg";
import iconRadioSelected from "@joyz/app-core/assets/icons/misc/TT4WRadioChecked.svg";
import iconVocabularyDrill from "@joyz/app-core/assets/icons/default/DrillVocabulary.svg";

interface Data {
  countOptions: number[];
  icons: {
    [iconName: string]:
      | string
      | {
          [iconName: string]: string;
        };
  };
  selectedIndex: number | null;
}

interface Methods {
  problemCountSelectionHandler: (index: number) => void;
}

interface Computed {
  backButtonString: string;
  nextButtonDisabled: boolean;
  selectedValue: number;
  title: string;
  titleIcon: string;
}

interface Props {
  cancelToLevelSelection: boolean;
  open: boolean;
  type: number;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "ProblemCountSelectionModal",
  props: {
    cancelToLevelSelection: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      countOptions: [10, 20, 50, 100],
      icons: {
        close: iconClose,
        listening: iconListeningDrill,
        pronunciation: iconPronunciationDrill,
        radio: {
          default: iconRadio,
          selected: iconRadioSelected
        },
        vocabulary: iconVocabularyDrill
      },
      selectedIndex: null
    };
  },
  computed: {
    backButtonString() {
      return this.cancelToLevelSelection ? "common.return" : "common.cancel";
    },
    nextButtonDisabled() {
      return this.selectedIndex === null;
    },
    selectedValue() {
      if (this.selectedIndex === null) return 0;
      return this.countOptions[this.selectedIndex];
    },
    title() {
      const practiceType = this.$__(`skills.practice.${SKILL_PRACTICE_TYPES[this.type]}`);
      const drillCount = this.$__("skills.practice.question-count.title");
      return `${practiceType}${drillCount}`;
    },
    titleIcon() {
      return this.icons[SKILL_PRACTICE_TYPES[this.type]] as string;
    }
  },
  methods: {
    problemCountSelectionHandler(index) {
      this.selectedIndex = index;
    }
  }
});
